var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerCut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0083 12.1001H19.9752C20.6111 12.1001 21.0064 12.791 20.6867 13.3376L18.0923 17.8189L10.3251 11.6794L10.907 7.3151C10.962 6.90604 11.3127 6.6001 11.7252 6.6001H16.6752C17.2149 6.6001 17.6102 7.11572 17.4727 7.63822L16.0083 12.1001ZM10.0382 13.8312L9.80704 15.5651C9.74173 16.0601 10.1267 16.5001 10.6252 16.5001H13.4146L10.0382 13.8312ZM14.5018 17.3594L13.1208 23.186C12.997 23.7085 13.3958 24.2001 13.9217 24.2001C14.2105 24.2001 14.4855 24.0488 14.6367 23.7876L17.1475 19.4507L14.5018 17.3594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8926 21.5917L5.97737 8.22117C5.77698 8.0618 5.74075 7.7663 5.89658 7.56106L6.46124 6.81804C6.61706 6.61281 6.90629 6.57576 7.10697 6.73542L24.0222 20.106C24.2226 20.2653 24.2589 20.5608 24.103 20.7661L23.5384 21.5091C23.3825 21.7143 23.0933 21.7511 22.8926 21.5917Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerCut);
export default __webpack_public_path__ + "static/media/power_cut.ffbde717da741c53a761ea0cf4d474cc.svg";
export { ForwardRef as ReactComponent };